// extracted by mini-css-extract-plugin
export default {"StyledTableRow":"tracked-by-missing-issues-row-module__StyledTableRow--eUD3d","BaseCell":"tracked-by-missing-issues-row-module__BaseCell--lJ1kM"};